import { Injectable } from '@angular/core';
import { Subject } from 'rxjs';
import { HttpClient } from '@angular/common/http';
import {MigrationStatusInfo} from '../models/migration-status-info';
import {MigrationModalData} from '../models/migration-modal-data';

@Injectable({ providedIn: 'root' })
export class MigrationService {
    public migrationModalData: Subject<MigrationModalData> = new Subject<MigrationModalData>();
    public migrationStatus: string;

    constructor(private httpClient: HttpClient) { }

    public show(migrationStatus: MigrationStatusInfo): void {
        document.getElementsByTagName('html').item(0).classList.add('migration-overlay');
        this.migrationModalData.next({
            visibility: true,
            data: migrationStatus
        });
    }

    public hide(): void {
        document.getElementsByTagName('html').item(0).classList.remove('migration-overlay');
        this.migrationModalData.next({
            visibility: false,
            data: null
        });
    }

    public getTenantMigrationStatus(): Promise<MigrationStatusInfo> {
        return new Promise<MigrationStatusInfo>((resolve, reject) => {
            this.httpClient.get<MigrationStatusInfo>(`/api/migration/status`)
                .subscribe((result: MigrationStatusInfo) => {
                    resolve(result);
                }, (error) => {
                    reject(error);
                })
        });
    }

    public updateTenantMigrationStatus(migrationRequestObj: MigrationStatusInfo): Promise<string> {
        return new Promise<string>((resolve, reject) => {
            this.httpClient.put<string>(`/api/migration/status`, migrationRequestObj)
                .subscribe((result) => {
                    resolve(result);
                }, (error) => {
                    reject(error);
                })
        });
    }

    public startUsersMigration(): Promise<string> {
        return new Promise<string>((resolve, reject) => {
            this.httpClient.post<string>(`/api/migration/MigrateUsers`, { tenantId: '', isManager: false })
                .subscribe((result) => {
                    resolve(result);
                }, (error) => {
                    reject(error);
                })
        });
    }

    public startDeviceMigration(): Promise<string> {
        return new Promise<string>((resolve, reject) => {
            this.httpClient.post<string>(`/api/migration/MigrateDevice`, { tenantId: '', SerialNumber: '' })
                .subscribe((result) => {
                    resolve(result);
                }, (error) => {
                    reject(error);
                })
        });
    }

    public startProjectsMigration(): Promise<string> {
        return new Promise<string>((resolve, reject) => {
            this.httpClient.post<string>(`/api/migration/MigrateProjects`, { migrateStartTime: new Date(), migrateEndTime: new Date() })
                .subscribe((result) => {
                    resolve(result);
                }, (error) => {
                    reject(error);
                })
        });
    }

    public startFilesMigration(): Promise<string> {
        return new Promise<string>((resolve, reject) => {
            this.httpClient.post<string>(`/api/migration/MigrateFiles`, { migrateStartTime: new Date(), migrateEndTime: new Date() })
                .subscribe((result) => {
                    resolve(result);
                }, (error) => {
                    reject(error);
                })
        });
    }
}
